import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

export default function ConfirmModal({ open, onConfirm, onCancel, title, description, hint, confirmLabel = "Continue", cancelLabel = "Cancel", variant = "default" }) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <AlertDialogContent
        className="border-[#2a2e36] rounded-2xl max-w-md"
        style={{ background: '#1a1d21' }}
      >
        <AlertDialogHeader>
          <AlertDialogTitle
            className="text-xl text-[#f4f4f5] tracking-tight"
            style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
          >
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-[#a1a1aa] mt-2 leading-relaxed">
            {description}
          </AlertDialogDescription>
          {hint && (
            <p className="text-[10px] text-[#52525b] font-mono tracking-wider mt-3">
              {hint}
            </p>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-6 gap-3">
          <AlertDialogCancel
            onClick={onCancel}
            className="btn-ghost border-[#363b45] text-[#a1a1aa] hover:text-[#c6a96f] hover:bg-[rgba(198,169,111,0.05)] rounded-xl"
            style={{ background: 'transparent' }}
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={`rounded-xl font-semibold text-sm ${
              variant === "destructive"
                ? "bg-[#c47272] text-white hover:bg-[#c47272]/80"
                : "btn-gold"
            }`}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
